<app-link-card-container
	[id]="link()?.value?.id"
	[isLoading]="isLoading()"
	[pillColor]="link()?.pillColor"
	[module]="moduleUrl()"
	[files]="link()?.value?.files"
	[statusValue]="link()?.value?.status"
	[title]="link()?.value.name">
	<div class="stack-item-container flex-row">
		<app-stack-label-item
			[label]="'locations|record|details-section|field-label|type'"
			[value]="
				link()?.value?.type | getTranslationKeyFromValue: types | transloco
			" />
	</div>
</app-link-card-container>
